<template>
  <BfTable
    :key="`visit_table_${data.length}`"
    ref="table"
    :columns="tableColumns"
    :data="data"
    border
    cell-class-name="tasaciones-small-cell"
    :max-height="maxHeight"
    @row-click="rowClick"
  >
    <template v-if="allowSelect" slot="table_checkbox" slot-scope="{row}">
      <BfCheckbox
        data-key="checkbox"
        :value="selectedRows.indexOf(row.id) >= 0"
        :bottom-gutter="false"
        :display-label="false"
        class="table-checkbox"
        @update="rowCheckboxChange($event, row)"
      />
    </template>
  </BfTable>
</template>

<script>
export default {
  name: 'VisitTable',

  props: {
    allowSelect: {
      type: Boolean,
    },

    data: {
      type: Array,
      default: () => [],
    },

    maxHeight: {
      type: [String, Number],
    },

    selectedRows: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    rowCheckboxChange({ value }, row) {
      this.$emit('row-checkbox-change', {
        row,
        value,
      });
    },

    rowClick(payload) {
      this.$emit('row-click', payload);
    },
  },

  computed: {
    tableColumns() {
      const checkboxCol = {
        label: '',
        dataKey: 'table_checkbox',
        width: '50',
      };

      return [
        ...(this.allowSelect ? [checkboxCol] : []),
        /* {
          label: 'Código',
          dataKey: 'id',
          width: '50',
        }, */
        {
          label: 'Fecha',
          dataKey: 'fecha',
          width: '120',
          sortable: true,
        },
        {
          label: 'Hora',
          dataKey: 'hora',
          width: '100',
          sortable: true,
        },
        {
          label: 'Población',
          dataKey: 'poblacion',
          width: '150',
          sortable: true,
        },
        {
          label: 'Dirección',
          dataKey: 'direccion',
          width: '200',
          sortable: true,
        },
        {
          label: 'Contacto',
          dataKey: 'contacto',
          width: '180',
          sortable: true,
        },
        {
          label: 'Teléfono',
          dataKey: 'telefono',
          width: '120',
          sortable: true,
        },
        {
          label: 'Nº Encargo',
          dataKey: 'codigo_encargo',
          sortable: true,
          width: '125',
        },
        {
          label: 'Solicitante',
          dataKey: 'solicitante_nombre',
          sortable: true,
          width: '200',
        },
        {
          label: 'Tipo de trabajo',
          dataKey: 'tipo_trabajo_nombre',
          sortable: true,
          width: '200',
        },
        {
          label: 'Tipo de inmueble',
          dataKey: 'tipo_de_inmueble',
          sortable: true,
          width: '200',
        },
        {
          label: 'Urg',
          dataKey: 'urgente',
          sortable: true,
          width: '70',
        },
        {
          label: 'Doc',
          dataKey: 'documentacion',
          sortable: true,
          width: '75',
        },
        {
          label: 'Int',
          dataKey: 'exterior',
          sortable: true,
          width: '70',
        },
        {
          label: 'Cliente',
          dataKey: 'cliente_nombre',
          sortable: true,
          width: '180',
        },
      ].map(col => ({ ...col, showOverflowTooltip: true }));
    },
  },
};
</script>

<style lang="scss" scoped>
.table-checkbox {
  text-align: center;
  padding-right: 2px;

  /deep/ .el-checkbox {
    margin-bottom: 0;

    &__label {
      display: none;
    }
  }
}
</style>
